import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../../App";
import AssetsModal from "../../containers/shared/AssetsModal";
import NormalButton from "../shared/NormalButton";
import moment from "moment";

export default function AssetsTable({ assets,currentPage=false,pageSize=0 }) {

    const navigate = useNavigate();

    const { AssetTypeOptions } = useContext(UserContext);

    const [selectedAssets, setSelectedAssets] = useState();
    const [showAssetsDetails, setShowAssetsDetails] = useState(false);


    const handleClickAssetsRow = (Assets) => {
        
    }

    const handleClickShowPopup = (Assets) => {
        // setSelectedAssets(Assets);
        // setShowAssetsDetails(true);
    }

    const handleCloseModal = () => {
        setShowAssetsDetails(false);
    }

    const assetsStatus = (status) => {
        switch(status) {
            case 'active':
                return <span className="text-success">يعمل</span>;
            case 'under_maintenance':
                return <span className="text-warning">تحت الصيانة</span>;
            case 'needs_replacement':
                return <span className="text-danger">يحتاج للتغيير</span>;
            case 'decommissioned':
                return <span className="text-grey-600">خارج الخدمة</span>;
            default:
                return <span className="">غير معرف</span>;
        }
    } 

    const handleShowAssetsDetails = (assets) => {
        setSelectedAssets(assets);
        setShowAssetsDetails(true);
    }

    const handleClickEditAssets = () => {
        navigate(`/ar/assets/edit/${selectedAssets?._id}`);
    }


    return (
        <>
        <div className="">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">النوع</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الماركة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الحالة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الوحدة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">تاريخ آخر صيانة</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]">التفاصيل</th>
                </tr>
                </thead>
                <tbody>
                {assets.map((Assets, index) => {;
                    return (
                    <tr key={`assets-${index}`} className={`${index !== assets?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === assets?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickAssetsRow(Assets)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickAssetsRow(Assets)}>{AssetTypeOptions[AssetTypeOptions?.findIndex(option => option?.value === Assets?.type)]?.label}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickAssetsRow(Assets)}>{Assets?.brand}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickAssetsRow(Assets)}>{assetsStatus(Assets?.status)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickAssetsRow(Assets)}>{`${Assets?.unitId?.name} (${Assets?.propertyId?.name})`}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickAssetsRow(Assets)}>{moment(Assets?.lastMaintenanceDate).format('DD MMM YYYY')}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === assets?.length-1 && 'rounded-bl-[8px]'}`} onClick={()=>handleClickShowPopup(Assets)}><div className="text-blue underline font-[600] text-[14px] cursor-pointer select-none" onClick={()=>handleShowAssetsDetails(Assets)}>تفاصيل الأصل</div></td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showAssetsDetails && <AssetsModal handleCloseModal={handleCloseModal}>
            <div className="">
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] px-[16px]">
                    <span className="text-[12px] text-grey-900 font-[600]">النوع:</span> {AssetTypeOptions[AssetTypeOptions?.findIndex(option => option?.value === selectedAssets?.type)]?.label}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الماركة:</span> {selectedAssets?.brand}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الحالة:</span> {assetsStatus(selectedAssets?.status)}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">رقم السريال:</span> {selectedAssets?.serialNumber}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">القيمة:</span> {selectedAssets?.costPerItem} <span className="inline-block w-[13px] h-[13px] align-middle" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">نسبة الإهلاك:</span> {selectedAssets?.depreciationRate*100} %
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الوحدة:</span> {`${selectedAssets?.unitId?.name} (${selectedAssets?.propertyId?.name})`}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">تاريخ الشراء أو التركيب:</span> {moment(selectedAssets?.lastMaintenanceDate).format('DD MMM YYYY')}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">عمر الأصل المتوقع:</span> {selectedAssets?.expectedLifeSpan} سنوات
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الضمان:</span> {selectedAssets?.hasWarranty ? 'نعم' : 'لا'}
                </div>
                { selectedAssets?.attachments?.length > 0 && 
                    <div className="text-[14px] text-grey-600 font-[500] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200 flex flex-nowrap">
                        <div className="text-[12px] text-grey-900 font-[600] whitespace-normal w-[93px]">مستندات الضمان:</div> 
                        <div className="ps-[15px]">
                        {selectedAssets?.attachments?.map((attachment,index)=>{
                            return (<div key={`attachment-${index}`} className="block align-middle mb-[5px]">
                                <Link download={true} className={`inline-block text-[16px] text-grey-600 font-[500] cursor-pointer select-none`} to={attachment?.url} target="_blank" rel="noopener noreferrer">
                                    <span dir="lrt">{attachment?.name}</span>
                                    <span className="inline-block align-middle w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/import.svg')"}}></span>
                                </Link>
                            </div>)
                        })}
                        </div>
                    </div>}
                <div className="text-end p-[16px]">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModal}>إلغاء</div>
                    <NormalButton label={'تعديل'} onClick={handleClickEditAssets} />
                </div>
            </div>
        </AssetsModal> }

        </>
    )
}

